export default "__VITE_ASSET__c15454a7__"